import React, { useState, useContext, useRef } from 'react';
import { EditText } from 'react-edit-text';
import 'react-edit-text/dist/index.css';
import { useDispatch, useSelector } from 'react-redux';
import DeleteIcon from '@mui/icons-material/Delete';
import imgThumbnail from '../../../../img/thumbnail.png';
import { handleRelatedPlatform } from '../../../../_services/creater/relatedPlatfom.service';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import YtMusic from '../../../../img/streaming-platform-images/yt-music.svg';
import JioSaavn from '../../../../img/streaming-platform-images/jio-saavn.svg';
import Wynk from '../../../../img/streaming-platform-images/wynk.svg';
import Spotify from '../../../../img/streaming-platform-images/spotify.svg';
import Hungama from '../../../../img/streaming-platform-images/hungama.svg';
import Gaana from '../../../../img/streaming-platform-images/gaana.svg';
import AmzazonMusic from '../../../../img/streaming-platform-images/amazon-music.svg';
import AppleMusic from '../../../../img/streaming-platform-images/apple-music.svg';
import YouTube from '../../../../img/streaming-platform-images/youtube.png';
import NotEmbeddedYoutube from '../../../../img/streaming-platform-images/embedded.svg';
import EmbeddedYoutube from '../../../../img/streaming-platform-images/embeddedtrue.svg';
import InstagramReel from '../../../../img/streaming-platform-images/instagram_1.svg';
import Deezer from '../../../../img/streaming-platform-images/Deezer.svg';
import Others from '../../../../img/streaming-platform-images/otherPlatform.png';
import facebook from '../../../../img/streaming-platform-images/facebook2.png'

import {
  setSnackBar,
  setSnackBarMessage,
  setSnackBarVariant,
} from '../../../../redux';
import { formSnackbar } from '../../../../_services/_constants/snackbar.constant';
import { StreamingPlatformContext } from './AddSong';
import DeleteModal from '../../../../components/reusableComponents/DeleteModal';
import { useEffect } from 'react';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';

const list = [
  {
    platformId: 0,
    platformName: 'Please Select..',
    platform_key: 'pleaseSelect',
  },
];

const AddPlatforms = ({
  deletePlatformHandler,
  reRenderPlatformHandler,
  addNewDisabledHandler,
  cardData,
  songId,
  cardId,
  index,
  allRelatedPlatforms,
  provided
}) => {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.userData.userData);
  const { allPlatfromList, handleAllPlatformList, allPlatfromListCopy } =
    useContext(StreamingPlatformContext); // to update streaming platform dropdown as per the selection
  const [selectedPlatform, setSelectedPlatform] = useState(list[0]);
  const [streamingLink, setStreamingLink] = useState(
    cardData ? cardData.streamingSonglink : null
  );
  const [platformImage, setPlatFormImage] = useState(imgThumbnail);
  const [urlError, setUrlError] = useState(false);
  const ref = useRef();
  const [playMode, setPlayMode] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(true);


  useEffect(() => {
    let platformList = allPlatfromListCopy;
    let selectedItem =
      platformList &&
      platformList.length > 0 &&
      platformList.findIndex((item, index) => {
        return item?.platformId === cardData.streamingPlatform;
      });
    let currentItem =
      platformList &&
      platformList.length > 0 &&
      platformList.find((item, index) => {
        return item?.platformId === cardData.streamingPlatform;
      });
    setSelectedPlatform(platformList[selectedItem]); //set the automatic selected value
    imageChangeHandler(platformList[selectedItem]); //set the image as per the selected item
    setPlayMode(cardData && cardData.play_mode)
    setSelectedStatus(cardData && cardData.status)
    //to auto remove the selected streaming platform from the dropdown
    allRelatedPlatforms &&
      allRelatedPlatforms.length > 0 &&
      handleAllPlatformList(allRelatedPlatforms, 'remove');
  }, []);


  function checkUrlString(string) {
    let expression = /https?:\/\/(www\.|(?!www)[A-Za-z0-9-]+\.[A-Za-z0-9]+[^\s]*)/gi;
    let regex = new RegExp(expression);
    try {
      if (string.match(regex)) {
        return true;
      } else {
        return false;
      }
    } catch (err) {
      return false;
    }
  }

  function checkUrlProtocol(string) {
    try {
      const url = new URL(string);
      if (url.protocol === 'http:' || url.protocol === 'https:') {
        if (url.hostname.substring(0, 1) !== '.') return true;
        else return false;
      } else {
        return false;
      }
    } catch (err) {
      return false;
    }
  }

  const imageChangeHandler = (currentObj) => {
    if (currentObj) {
      switch (currentObj.platform_key) {
        case 'jiosaavn': {
          setPlatFormImage(JioSaavn);
          break;
        }
        case 'wynk': {
          setPlatFormImage(Wynk);
          break;
        }
        case 'spotify': {
          setPlatFormImage(Spotify);
          break;
        }
        case 'hungama': {
          setPlatFormImage(Hungama);
          break;
        }
        case 'gaana': {
          setPlatFormImage(Gaana);
          break;
        }
        case 'amazon music':
        case 'amazonmusic': {
          setPlatFormImage(AmzazonMusic);
          break;
        }
        case 'applemusic': {
          setPlatFormImage(AppleMusic);
          break;
        }
        case 'youtube music':
        case 'youtubemusic': {
          setPlatFormImage(YtMusic);
          break;
        }
        case 'youtube': {
          setPlatFormImage(YouTube);
          break;
        }
        case 'Instagrammakereels':
          case 'instagram': {
          setPlatFormImage(InstagramReel)
          break;
        }
        case 'others': {
          setPlatFormImage(Others);
          break;
        }
        case 'deezer': {
          setPlatFormImage(Deezer);
          break;
        }
        case 'facebook': {
          setPlatFormImage(facebook);
          break;
        }
        case undefined: {
          setPlatFormImage(imgThumbnail);
        }
        default: {
          break;
        }
      }
    } else setPlatFormImage(imgThumbnail);
  };

  const platformChangeHandler = (e, newValue) => {
    if (newValue) {
      selectedPlatform != undefined &&
        handleAllPlatformList(
          { previousValue: selectedPlatform, latestValue: newValue },
          'update'
        ); //to remove and add the platforms dropdown if already added platform get updated
      imageChangeHandler(newValue);

      setSelectedPlatform(newValue);
    } else {

    }
  };

  function getId(url, platform) {
    var youTuberegExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    var spotifyregExp = /https:\/\/open\.spotify\.com\/(track|album|playlist)\/([a-zA-Z0-9]+)(\?si=[a-zA-Z0-9]+)?/;

    if (platform == 'spotify') {
      var match = url.match(spotifyregExp);
      if (match && match[2]) {
        return match[2];
      } else {
        return 'error';
      }
    }
    else {
      var match = url.match(youTuberegExp);
      if (match && match[2].length === 11) {
        return match[2];
      } else {
        return 'error';
      }
    }
  }
  const platformDomainMap = {
    jiosaavn: ['jiosaavn.com', 'music.jiosaavn.com'],
    youtube: ['youtube.com', 'youtu.be', 'music.youtube.com'],
    spotify: ['spotify.com', 'open.spotify.com'],
    amazonmusic: ['music.amazon.com', 'amazon.com', 'music.amazon.in'],
    hungama: ['hungama.com', 'music.hungama.com'],
    gaana: ['gaana.com', 'music.gaana.com'],
    youtubemusic: ['music.youtube.com', 'youtube.com'],
    applemusic: ['music.apple.com', 'itunes.apple.com'],
    Instagrammakereels: ['instagram.com', 'music.instagram.com'],
    deezer: ['deezer.com', 'music.deezer.com'],
  };
  //  'music.amazon.com/albums', 'music.amazon.com/tracks', 'music.amazon.in/albums', 'music.amazon.in/tracks',
  const isPlatformLinkValid = (url, platformKey) => {
    const expectedDomains = platformDomainMap[platformKey] || [];
    try {
      const parsedUrl = new URL(url);
      return expectedDomains.some(domain => parsedUrl.hostname.includes(domain));
    } catch {
      return false;
    }
  };

  const handlePlatformLinkSave = ({ name, value, previousValue }) => {
    setStreamingLink(value);
    const linkStatus = isYouTubeLink(value);
    let streamLink = linkStatus ? embededURL(playMode, value) : value;

    const isEmpty = value === '';

    if (isEmpty || (checkUrlString(value) && checkUrlProtocol(value))) {
      // Validate platform-specific URL
      if (!isEmpty && !isPlatformLinkValid(value, selectedPlatform?.platform_key)) {
        setUrlError(`Please enter a valid link for ${selectedPlatform?.platformName}`);
        return;
      }

      setUrlError(null);
      userData.id && cardId == undefined
        ? createRelatedPlatformLink({
          streamingSonglink: streamLink, streamingPlatform: selectedPlatform?.platformId,
          streamingPlatformCode: selectedPlatform.platform_key
        })
        : updateRelatedPlatformLink({
          streamingSonglink: streamLink, streamingPlatform: selectedPlatform?.platformId,
          streamingPlatformCode: selectedPlatform.platform_key
        });
    } else {
      setUrlError('Please enter a valid URL');
    }
  };

  function isYouTubeLink(url) {
    const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+$/;
    return youtubeRegex.test(url);
  }

  const createRelatedPlatformLink = (postObj) => {
    dispatch(setSnackBar(true));
    dispatch(setSnackBarMessage(formSnackbar.relatedPlatform.realtedPlatformCreate));
    dispatch(setSnackBarVariant('info'));
    postObj.songId = songId;
    postObj.userId = userData.id;
    handleRelatedPlatform(postObj, 'POST')
      .then((response) => {
        if (response.status === 200) {
          dispatch(setSnackBarMessage(formSnackbar.relatedPlatform.realtedPlatformCreateSuccess));
          dispatch(setSnackBarVariant('success'));
          setTimeout(() => {
            dispatch(setSnackBar(false));
          }, 2000);
          const getRelatedPlatformId = response.data.data[0].fields.songId.id;
          reRenderPlatformHandler(getRelatedPlatformId);
          addNewDisabledHandler();
        } else {
          if (response.status == 400) {
            dispatch(setSnackBarMessage(response.data.error[0]));
            dispatch(setSnackBarVariant('error'));
            setTimeout(() => {
              dispatch(setSnackBar(false));
            }, 2000);
          } else {
            dispatch(setSnackBarMessage(formSnackbar.serviceRequest.serviceRequestFailure));
            dispatch(setSnackBarVariant('error'));
            setTimeout(() => {
              dispatch(setSnackBar(false));
            }, 2000);
          }
        }
      })
      .catch((error) => {
        alert(error);
      });
  };

  const updateRelatedPlatformLink = (postObj) => {
    dispatch(setSnackBar(true));
    dispatch(setSnackBarMessage(formSnackbar.relatedPlatform.realtedPlatformUpdate));
    dispatch(setSnackBarVariant('info'));
    postObj.songId = songId;
    postObj.relatedPlatformLinkId = cardId;
    handleRelatedPlatform(postObj, 'UPDATE')
      .then((response) => {
        if (response.status === 200) {
          dispatch(setSnackBarMessage(formSnackbar.relatedPlatform.realtedPlatformUpdateSuccess));
          dispatch(setSnackBarVariant('success'));
          setTimeout(() => {
            dispatch(setSnackBar(false));
          }, 2000);
          reRenderPlatformHandler(songId);
          addNewDisabledHandler();
        } else {
          if (response.status == 400) {
            dispatch(setSnackBarMessage(response.data.error[0]));
            dispatch(setSnackBarVariant('error'));
            setTimeout(() => {
              dispatch(setSnackBar(false));
            }, 2000);
          } else {
            dispatch(setSnackBarMessage(formSnackbar.errors.errorMsg));
            dispatch(setSnackBarVariant('error'));
            setTimeout(() => {
              dispatch(setSnackBar(false));
            }, 2000);
          }
        }
      })
      .catch((error) => {
        alert(error);
      });

  };

  const updateURLWithYouTubeID = (youtubeID, type) => {
    if (type === 'embed') {
      const url = 'https://www.youtube.com/embed/' + youtubeID;
      return url;
    }
    else {
      const url = 'https://www.youtube.com/watch?v=' + youtubeID;
      return url;
    }
  };

  const updateURLWithSpotifyID = (spotifyID, type) => {
    if (type === 'embed') {
      const url = 'https://open.spotify.com/embed/track/' + spotifyID;
      return url;
    }
    else {
      const url = 'https://open.spotify.com/track/' + spotifyID;
      return url;
    }
  };


  const embededURL = (value, link) => {
    const postObj = {}
    const urlId = getId(link, selectedPlatform.platform_key);
    if (selectedPlatform.platform_key == 'spotify') {
      if (value) {
        const embedLink = updateURLWithSpotifyID(urlId, 'embed')
        setStreamingLink(embedLink)
        return postObj.streamingSonglink = embedLink
      } else {
        const watchLink = updateURLWithSpotifyID(urlId, 'track')
        setStreamingLink(watchLink)
        return postObj.streamingSonglink = watchLink
      }
    } else {
      if (value) {
        const embedLink = updateURLWithYouTubeID(urlId, 'embed')
        setStreamingLink(embedLink)
        return postObj.streamingSonglink = embedLink
      }
      else {
        const watchLink = updateURLWithYouTubeID(urlId, 'watch')
        setStreamingLink(watchLink)
        return postObj.streamingSonglink = watchLink
      }
    }
  }

  const playModeChangeHandler = (event, value) => {
    const isEmbeddedSelected =
      selectedPlatform && selectedPlatform.platform_key === 'youtube' || selectedPlatform && selectedPlatform.platform_key === 'spotify';
    const isLinkPresent =
      streamingLink && streamingLink.trim() !== '';
    if (isEmbeddedSelected && isLinkPresent) {
      setPlayMode(!playMode)
      const newlink = embededURL(value, streamingLink)
      const postObj = {
        songId: songId,
        relatedPlatformLinkId: cardId,
        play_mode: value ? true : false,
        streamingSonglink: newlink
      };
      handleRelatedPlatform(postObj, 'UPDATE')
        .then((response) => {
          if (response.status === 200) {
            dispatch(setSnackBarMessage(formSnackbar.relatedPlatform.realtedPlatformUpdateSuccess));
            dispatch(setSnackBarVariant('success'));
            setTimeout(() => {
              dispatch(setSnackBar(false));
            }, 2000);
            reRenderPlatformHandler(songId);
            addNewDisabledHandler();
          } else {
            dispatch(setSnackBarMessage(formSnackbar.errors.errorMsg));
            dispatch(setSnackBarVariant('error'));
            setTimeout(() => {
              dispatch(setSnackBar(false));
            }, 2000);
          }
        })
        .catch((error) => {
          alert(error);
        });
    } else {
      setUrlError('YouTube platform and link are required.')
    }

  };

  // ------------------- AddStreamingPlatform -----------------

  const platformStatusChangeHandler = (e) => {
    setSelectedStatus(e.target.checked);
    userData.id && cardId == undefined
      ? createRelatedPlatformLink({
        status: e.target.checked,
      })
      : updateRelatedPlatformLink({
        status: e.target.checked,
      });
  };
  const isDisabled = cardData?.songId?.is_admin_created;

  return (
    <>
      {/* ONE ROW OF A LIST, not a form in a box.
          What was here: a 71px circle, two full-width grey slabs stacked under
          a heading-sized dropdown, and the toggles pinned to the card's corner
          with `position: absolute` — a card 120px tall to hold a name and a
          link. This is the same four things the song list's own row settled on
          — handle, art, identity, actions — so the two lists read alike.

          Its class names are its own. The markup it replaced wore `.link-box`
          and `.link-details`, which the creator links, album tracks and
          playlist songs all still wear; restyling those would have redesigned
          three screens nobody asked about. */}
      <div
        ref={cardId !== undefined ? provided.innerRef : null}
        {...(cardId !== undefined ? provided.draggableProps : null)}
        {...(cardId !== undefined ? provided.dragHandleProps : null)}
        id={`song_${cardId}`}
        data-song-id={cardId}
        className={`plat-row${isDisabled ? ' is-locked' : ''}`}
      >
        <span className="plat-row__drag" aria-hidden="true">
          <DragIndicatorIcon fontSize="small" />
        </span>

        <span className="plat-row__art">
          <img src={platformImage} alt="" />
        </span>

        <div className="plat-row__fields">
          <Autocomplete
            options={allPlatfromList}
            getOptionLabel={(option) => (option.platformName ? option.platformName : '')}
            value={selectedPlatform}
            onChange={platformChangeHandler}
            size="small"
            className="plat-row__pick"
            disabled={isDisabled}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Add platform"
                variant="standard"
                disabled={isDisabled}
                InputProps={{ ...params.InputProps, disableUnderline: true }}
              />
            )}
          />

          {/* The link only appears once there is a platform to hang it on:
              a URL box above an empty dropdown is a field for a thing that
              does not exist yet. */}
          {selectedPlatform && (
            <div className="plat-row__link">
              <EditText
                name="streaming-link"
                className={`${isDisabled ? 'blurred-disabled ' : ''}w-100`}
                onSave={handlePlatformLinkSave}
                readonly={isDisabled || !selectedPlatform}
                defaultValue={streamingLink}
                placeholder="Add link"
              />
              {urlError && (
                <div className="custom-tooltip">
                  <span className="tooltip-text">{urlError}</span>
                  <span className="top"></span>
                </div>
              )}
            </div>
          )}
        </div>

        {/* Every control this row has, in one column on the right, in the
            order they are reached for: play it inline, show it at all, remove
            it. They used to be absolutely positioned over the card's corner,
            which is why the card had to be tall enough to have one. */}
        <div className="plat-row__actions">
          {selectedPlatform
            && (selectedPlatform.platform_key === 'youtube' || selectedPlatform.platform_key === 'spotify') && (
            <label className="switch cursorPointer plat-row__embed">
              {!playMode ? (
                <img
                  onClick={(e) => playModeChangeHandler(e, true)}
                  src={NotEmbeddedYoutube}
                  title="Play inline on your page"
                  alt={selectedPlatform.platform_key === 'spotify' ? 'EmbeddedSpotify' : 'EmbeddedYoutube'}
                />
              ) : (
                <img
                  onClick={(e) => playModeChangeHandler(e, false)}
                  title="Open on the platform instead"
                  src={EmbeddedYoutube}
                  alt="EmbeddedYoutube"
                />
              )}
            </label>
          )}

          <label className="switch">
            <input
              checked={cardData?.status || selectedStatus}
              type="checkbox"
              id={cardId}
              role="switch"
              onChange={platformStatusChangeHandler}
            />
            <span
              className="slider round"
              style={{ opacity: (selectedStatus === false && streamingLink === '') ? 0.3 : 1 }}
              title={selectedStatus === true ? 'Showing on your page' : 'Hidden from your page'}
            ></span>
          </label>

          <button
            type="button"
            title="Delete"
            className={`${isDisabled ? 'blurred-disabled ' : ''}plat-row__delete`}
            disabled={isDisabled}
            onClick={isDisabled
              ? undefined
              : (e) => (cardData && cardData.id !== undefined
                ? ref.current.handleOpen()
                : deletePlatformHandler(e, songId, cardId, index, cardData))}
          >
            <DeleteIcon fontSize="small" />
          </button>
        </div>
      </div>

      <DeleteModal
        cardId={cardId && cardId}
        deleteHandler={(e) => deletePlatformHandler(e, songId, cardId, index, cardData)}
        ref={ref}
      />
    </>
  );
};

export default AddPlatforms;
